import i18n from '~/utils/i18n';

/**
 * Gets the current locale in the format used by the application (e.g., 'en_US')
 * @returns The current locale string or 'en_US' as fallback
 */
export function getCurrentLocale(): string {
  return i18n?.language || 'en_US';
}

/**
 * Gets the current locale in the format used by Luxon (e.g., 'en')
 * @returns The current locale string in Luxon format or 'en' as fallback
 */
export function getLuxonLocale(): string {
  const locale = getCurrentLocale();
  // Convert locale format from 'en_US' to 'en' for Luxon
  return locale.split('_')[0];
}

/**
 * Normalizes a language code by converting formats like 'en_US' to 'en'
 * @param language The language code to normalize
 * @returns The normalized language code or 'en' as fallback
 */
export function normalizeLanguage(language: string): string {
  if (!language) return 'en';
  // Convert language format from 'en_US' to 'en'
  return language.split('_')[0];
}
